import { render, staticRenderFns } from "./addLimited.vue?vue&type=template&id=bd36cd1a&"
import script from "./addLimited.vue?vue&type=script&lang=js&"
export * from "./addLimited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports